import { render } from "./Cenik.vue?vue&type=template&id=7053bb16"
import script from "./Cenik.vue?vue&type=script&lang=js"
export * from "./Cenik.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__